export default function (size = 1025, smaller = '<') {
    if (smaller == '<') {
        return window.innerWidth < size;
    } else {
        return window.innerWidth > size;
    }
}